import type { ApiError, ApiErrorResponse } from "./hooks/types";

const isNonEmptyString = (value: unknown): value is string =>
  typeof value === "string" && value.trim().length > 0;

const getValidationErrorMessage = (errors: ApiErrorResponse["errors"]) => {
  if (!errors) return undefined;

  for (const key of Object.keys(errors)) {
    const value = errors[key];

    if (Array.isArray(value)) {
      const message = value.find(isNonEmptyString);

      if (message) return message;
      continue;
    }

    if (isNonEmptyString(value)) return value;
  }

  return undefined;
};

export const getApiErrorMessage = (error: ApiError | null | undefined) => {
  const responseData = error?.response?.data;
  const message =
    (isNonEmptyString(responseData?.Message)
      ? responseData.Message
      : undefined) ??
    (isNonEmptyString(responseData?.message)
      ? responseData.message
      : undefined) ??
    getValidationErrorMessage(responseData?.errors) ??
    (isNonEmptyString(responseData?.detail)
      ? responseData.detail
      : undefined) ??
    (isNonEmptyString(responseData?.title) ? responseData.title : undefined);

  if (message) return message;

  const status = error?.response?.status;

  if (status === 429) {
    return "Too many requests. Please try again later.";
  }

  if (status === 422) {
    return "Captcha verification failed. Please try again.";
  }

  return "An unexpected error occurred. Please try again.";
};
